(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Main', Main);

    Main.$inject = ['$resource'];

    function Main ($resource) {
        var resourceUrl =  'macroforecast/timeseries-data';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
